import { projectStatus } from '@/server/constants'

// LSO-525 option 1: editing a question's phase or required flag on an active
// project changes what participants see with no notification. Ask the owner
// to confirm before saving. Resolves true when there is nothing to confirm or
// the owner agreed, false when they cancelled.
export const needsActiveProjectConfirmation = (project, { required, phase }) => {
  if (!project || project.status === undefined || project.status < projectStatus.active) {
    return false
  }
  return required || phase
}

const confirmActiveProjectQuestionChange = async (vm, project, { required = false, phase = false, count = 1 } = {}) => {
  if (!needsActiveProjectConfirmation(project, { required, phase })) {
    return true
  }
  const h = vm.$createElement
  const changed = [required && 'required setting', phase && 'phase'].filter(Boolean).join(' and ')
  const noun = count === 1 ? 'this question' : `these ${count} questions`
  const customMsg = h('div', [
    h('p', `This project is active. Changing the ${changed} of ${noun} takes effect for participants immediately.`),
    h('ul', [
      h('li', 'Participants will not be notified of the change.'),
      h('li', 'Properties already marked finished may now have unanswered required questions, and will keep their finished status.'),
      h('li', 'Eliminated and archived properties are affected in the same way.')
    ]),
    h('p', 'Do you want to continue?')
  ])
  return vm.$bvModal.msgBoxConfirm([customMsg], {
    title: 'Active Project: Participants Will Not Be Notified',
    okVariant: 'danger',
    okTitle: 'Continue',
    cancelVariant: 'light',
    cancelTitle: 'Cancel',
    footerBgVariant: 'dark',
    headerBgVariant: 'warning',
    hideHeaderClose: true,
    centered: true
  })
}

export default confirmActiveProjectQuestionChange
